// extracted by mini-css-extract-plugin
export default {"employee-container":"Employees_employee-container__RCpQ0"};